/* eslint-disable react/require-default-props */
import React from 'react';
import styled from '@emotion/styled';
import { book, black, colors, regular, semiBold } from '@/styles';
import { Button, ButtonProps } from '@/atoms';
import { StyledComponent } from '@/helpers';
import { Layout } from '@/constants';

export type ConfirmationScreenProps = StyledComponent & {
  title: string;
  subtitle?: string;
  accept: {
    label: string;
    action: React.MouseEventHandler;
  };
  cancel: {
    label: string;
    action: React.MouseEventHandler;
  };
  layout?: Layout;
  isRebrand?: boolean;
  buttonColor?: ButtonProps['color'];
};

/**
 * ConfirmationScreen component
 */
function ConfirmationScreen({
  className,
  title,
  subtitle = '',
  accept,
  cancel,
  layout = 'default',
  isRebrand = false,
  buttonColor = 'taos-sky',
}: ConfirmationScreenProps) {
  return (
    <div className={`${className} layout--${layout}`}>
      <div className="title">{title}</div>
      <div className="sub-title">
        {subtitle.split('\n').map((text) => (
          <React.Fragment key={text}>
            {text}
            <br />
          </React.Fragment>
        ))}
      </div>
      <div className="button">
        <Button
          label={accept.label}
          onClick={accept.action}
          color={buttonColor}
          isRebrand={isRebrand}
        />
      </div>
      <button className="custom-button" type="button" onClick={cancel.action}>
        {cancel.label}
      </button>
    </div>
  );
}

const styledConfirmationScreen = styled(ConfirmationScreen)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  > button.custom-button {
    ${({ isRebrand = false }) => (isRebrand ? regular() : book())}
  }

  .title {
    ${({ isRebrand = false }) => (isRebrand ? semiBold() : black())}
    font-size: 1.375rem;
    color: ${colors.battleship};
    margin-top: 0.625rem;
  }

  .sub-title {
    ${({ isRebrand = false }) => (isRebrand ? regular() : book())}
    font-size: 0.875rem;
    color: ${colors.boulder};
    margin-top: 1rem;
  }

  .button {
    margin-top: 1.687rem;

    button {
      width: 8.75rem;
      margin: 0 auto;
    }
  }

  .custom-button {
    ${book()}
    margin-top: 0.687rem;
    color: ${colors.boulder};
    font-size: 0.812rem;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  &.layout--compact {
    .title {
      font-size: ${20 / 16}rem;
    }
    .subtitle {
      font-size: 1rem;
      line-height: ${21 / 16}rem;
    }
    .button {
      margin-top: 1.3rem;
    }
  }
`;

export default styledConfirmationScreen;
